(() => {
  'use strict';
  const popup = document.querySelector('#newsletterPopup');
  if (!popup) return;
  const forcePreview = new URLSearchParams(location.search).get('newsletter_popup') === '1';
  if (window.Shopify?.designMode && !forcePreview) return;
  const key = '58g-newsletter-popup-seen';
  let seen;
  try { seen = sessionStorage.getItem(key) === '1'; }
  catch { return; } // Do not repeatedly interrupt visitors if storage is blocked.
  const response = location.hash === '#NewsletterPopupForm' && popup.querySelector('[data-newsletter-response]');
  const open = () => {
    if (document.hidden || document.querySelector('dialog[open]')) {
      window.setTimeout(open, 1000);
      return;
    }
    if (!forcePreview) {
      try { sessionStorage.setItem(key, '1'); } catch { return; }
    }
    const previousFocus = document.activeElement;
    popup.show();
    previousFocus?.focus({ preventScroll: true });
  };
  popup.querySelector('.newsletter-popup-close').addEventListener('click', () => popup.close());
  popup.addEventListener('click', event => {
    const box = popup.getBoundingClientRect();
    if (event.target === popup && (event.clientX < box.left || event.clientX > box.right || event.clientY < box.top || event.clientY > box.bottom)) popup.close();
  });
  popup.addEventListener('cancel', event => { event.preventDefault(); popup.close(); });
  popup.addEventListener('keydown', event => {
    if (event.key === 'Escape') { event.preventDefault(); popup.close(); }
  });
  // Non-modal panel keeps the page available while open.
  addEventListener('pagehide', () => { if (popup.open) popup.close(); });
  if (response) open();
  else if (forcePreview || !seen) {
    window.addEventListener('58g:newsletter-ready', open, { once: true });
  }
})();
